// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_AuNvz","shareBtn":"index_shareBtn_28x-Z","mask":"index_mask_ztEON","tips":"index_tips_CuaaY","close":"index_close_LaalZ"};